import { Select, Input, Tabs, Checkbox, Dropdown } from 'antd';
import moment from 'moment';
import React, { useContext, useEffect, useState } from 'react';
import { Controller, useForm, useFieldArray } from 'react-hook-form';
import { useSelector } from 'react-redux';
import axios from '../../axios/axios';
import { toast } from 'react-toastify';
import { CommomPermission, IMAGE_BASE_URL } from '../../common/Constants';
import { useNavigate } from 'react-router-dom';
import { AuthenticationContext } from '../../App';

const FlooringNotificationBar = (props) => {
  const {
    adminNotifications,
    OnNotificationSelecct,
    notificationTabs,
    onFilterChange,
    onSearch,
    loading,
    selectedNotification,
    applyFilters,
    reload,
    notfBar,
    onFilterRead,
    selectedNotifications,
    setSelectedNotifications,
    selecAll,
    setSelecAll,
  } = props;
  const navigate = useNavigate();
  const { authData } = useContext(AuthenticationContext);
  const FlooringPErmission = authData?.permissions
    ?.filter((it) => it.name === 'flooring')
    ?.map((itx) => itx?.submodules)
    .flat()
    ?.filter((its) => its?.name === 'flooring-cases');
  const FloorPagePErmission =
    FlooringPErmission !== undefined && FlooringPErmission?.length > 0
      ? FlooringPErmission[0]
      : CommomPermission;

  const { control, getValues, setValue, watch } = useForm({
    defaultValues: {
      msgCheck: [],
    },
  });
  const msgCheckValues = watch('msgCheck');
  const [isRead, setIsRead] = useState(false);
  const items = [
    {
      label: (
        <div
          onClick={() =>
            onFilterRead(selecAll ? "ALLRead" : "read", selectedNotifications)
          }
        >
          Mark as read
        </div>
      ),
      key: '0',
    },
    {
      label: (
        <div
          onClick={() =>
            onFilterRead(selecAll ? "ALLUnread" : "unread", selectedNotifications)
          }
        >
          Mark as unread
        </div>
      ),
      key: '1',
    },
  ];
  async function handleNotifications(type) {
    const tokenId = localStorage.getItem('dealerModuleToken');
    const selectValues = getValues();
    const notfItems = selectValues?.msgCheck.filter((item) => item && item);
    let postApi = '/notification/bulk/update/1';
    if (notfItems.length > 0) {
      let postApi = '/notification/bulk/update/1';
      if (type === 'unread') {
        postApi = '/notification/bulk/update/0';
      }
      const resp = await axios.post(
        `${postApi}`,
        {
          items: notfItems,
        },
        {
          headers: {
            Authorization: `Bearer ${tokenId}`,
          },
        }
      );
      if (resp) {
        reload();
        setIsRead(false);
        setValue('msgCheck', []);
        setSelecAll(false);
      }
    } else {
      toast.error('Please select checkbox to Read/Unread the message');
    }
  }

  console.log(
    'adminNotifications',
    adminNotifications?.map((it) => it?.read_at)
  );
  return (
    <>
      <div
        className={`backDrop ${!notfBar ? 'hidden' : ''}`}
        onClick={() => props.notfBarClose(false)}
      ></div>
      <div
        className={`w-[430px] max-[600px]:w-[330px] side_not_bar scBarHidden h-screen overflow-y-auto sticky top-0 border-r border-[#EAEAEA] ${notfBar && 'active'
          }`}
      >
        <div className='pt-[30px] px-[25px] max-[600px]:px-[15px] bg-[#F5F5F5] sticky top-0 z-[2]'>
          <div className='flex items-center justify-between gap-[10px]'>
            <div>
              <h2 className='text-[20px] font-[700] text-black'>
                Flooring Notifications
              </h2>
            </div>
            <div className='flex gap-[7px] items-center'>
              <span className='flex gap-[5px] items-center text-[#59758A] text-[12px] w-[12px]'>
                <img src='/images/u_sort_ic.svg' />
              </span>
              <Select
                className='sortBySelect'
                rootClassName='sortBySelectDrop'
                suffixIcon={false}
                defaultValue={'week'}
                value={applyFilters?.sortBy}
                options={[
                  { label: 'Last 7 days', value: '7' },
                  { label: 'Last Month', value: '31' },
                  { label: 'Last 6 Monts', value: '185' },
                  { label: 'Last Year', value: '366' },
                ]}
                onChange={(value) => {
                  onFilterChange('sortBy', value);
                }}
              />
            </div>
          </div>

          <div className='mt-[15px] mb-[10px]'>
            <Input
              className='notSearchInp'
              prefix={<img src='/images/search.svg' alt='search' />}
              placeholder='Search...'
              allowClear
              onChange={(e) => {
                onSearch(e.target.value);
              }}
            />
          </div>
          <div>
            <Tabs
              id='notFicTab'
              activeKey={
                applyFilters?.productType !== undefined
                  ? applyFilters?.productType
                  : ''
              }
              items={notificationTabs}
              onChange={(key) => {
                onFilterChange('productType', key);
              }}
            />
          </div>
        </div>
        {adminNotifications?.length > 0 ? (
          adminNotifications?.map((item, index) => {
            let updatedDate = "";
            const itemDate = moment(item?.date, "DD-MM-YYYY");
     
            const today = moment().startOf("day");
            const yesterday = moment().subtract(1, "days").startOf("day");
            if (itemDate.isSame(today, "day")) {
              updatedDate = "Today";
            } else if (itemDate.isSame(yesterday, "day")) {
              updatedDate = "Yesterday";
            } else {
              updatedDate = itemDate.format("MMMM DD YYYY");
            }
            return (
              <>
                {index !== 0 ? (
                  moment(adminNotifications[index - 1]?.date).format(
                    'MMMM  DD YYYY'
                  ) !==
                    moment(adminNotifications[index]?.date).format(
                      'MMMM  DD YYYY'
                    ) ? (
                    <>
                      <div className='flex justify-between items-center z-[2] sticky top-[205px]' key={index}>
                        {index === 0 && (
                          <>
                            {isRead && (
                              <div className='absolute top-[50%] translate-y-[-50%] left-[25px] cursor-pointer flex items-center'>
                                {isRead && (
                                  <Checkbox
                                    checked={selecAll}
                                    onChange={(e) => {
                                      if (e.target.checked) {
                                        setValue(
                                          'msgCheck',
                                          adminNotifications.map((item) => {
                                            return item?.groupby;
                                          })
                                        );
                                        setSelecAll(true);
                                        setSelectedNotifications(
                                          adminNotifications?.map(
                                            (it) => it?.id
                                          )
                                        );
                                      } else {
                                        setValue('msgCheck', []);
                                        setSelecAll(false);
                                        setSelectedNotifications([]);
                                      }
                                    }}
                                  />
                                )}
                                <Dropdown menu={{ items }} trigger={['click']}>
                                  <img src='/images/men_bar.png' alt='edit' />
                                </Dropdown>
                              </div>
                            )}
                            <div
                              className='absolute top-[50%] translate-y-[-50%] right-[10px] cursor-pointer text-[13px] text-[#3498db]'
                              onClick={() => setIsRead(!isRead)}
                            >
                              Read/Unread
                            </div>
                          </>
                        )}
                      </div>
                      <div className='text-center py-[15px] sticky top-[176px] z-[1] bg-white'>
                        <div className='inline-block p-[5px_8px] text-[12px] rounded-[5px] bg-[#DDEAFF]'>
                          {updatedDate}
                        </div>
                      </div>
                    </>
                  ) : (
                    ''
                  )
                ) : (
                  <>
                    <div className='flex justify-between items-center z-[2] sticky top-[205px]'>
                      {index === 0 && (
                        <>
                          {isRead && (
                            <div className='absolute top-[50%] translate-y-[-50%] left-[25px] cursor-pointer flex items-center'>
                              {isRead && (
                                <Checkbox
                                  checked={selecAll}
                                  onChange={(e) => {
                                    if (e.target.checked) {
                                      setValue(
                                        'msgCheck',
                                        adminNotifications.map((item) => {
                                          return item?.groupby;
                                        })
                                      );
                                      setSelecAll(true);
                                      setSelectedNotifications(
                                        adminNotifications?.map((it) => it?.id)
                                      );
                                    } else {
                                      setValue('msgCheck', []);
                                      setSelecAll(false);
                                      setSelectedNotifications([]);
                                    }
                                  }}
                                />
                              )}
                              <Dropdown menu={{ items }} trigger={['click']}>
                                <img src='/images/men_bar.png' alt='edit' />
                              </Dropdown>
                            </div>
                          )}
                          <div
                            className='absolute top-[50%] translate-y-[-50%] right-[10px] cursor-pointer text-[13px] text-[#3498db]'
                            onClick={() => setIsRead(!isRead)}
                          >
                            Read/Unread
                          </div>
                        </>
                      )}
                    </div>
                    <div className='text-center py-[15px] sticky top-[176px] z-[1] bg-white'>
                      <div className='inline-block p-[5px_8px] text-[12px] rounded-[5px] bg-[#DDEAFF]'>
                        {updatedDate}
                      </div>
                    </div>
                  </>
                )}
                <div className='p-[10px_15px]'>
                  <div
                    className={
                      item?.index === selectedNotification?.index
                        ? 'notf_Sec p-[10px] bg-[#edf1f5b8]'
                        : 'notf_Sec p-[10px]'
                    }
                  >
                    <div
                      className='notf_card_box cursor-pointer flex items-center gap-[10px]'
                      onClick={() => {
                        if (item?.product_info !== null) {
                          OnNotificationSelecct(item?.id)
                        }
                      }}
                    >
                      {isRead && (
                        <Controller
                          control={control}
                          name={`msgCheck[${index}]`}
                          defaultValue={false}
                          render={({ field }) => {
                            return (
                              <Checkbox
                                {...field}
                                checked={selectedNotifications?.includes(
                                  item?.id
                                )}
                                onChange={(e) => {
                                  if (e.target.checked) {
                                    setSelectedNotifications(
                                      selectedNotifications?.concat(item?.id)
                                    );
                                  } else {
                                    setSelectedNotifications(
                                      selectedNotifications?.filter(
                                        (it) => it !== item?.id
                                      )
                                    );
                                  }
                                }}
                                onClick={(e) => {
                                  e.stopPropagation();
                                }}
                              />
                            );
                          }}
                        />
                      )}
                      <div className='h-[50px] w-[50px] rounded-[8px] border border-[#DEDEDE] shrink-0'>
                        <img
                          src={`${IMAGE_BASE_URL}${item?.data?.logo}`}
                          className='rounded-[8px] object-contain h-full w-full'
                        />
                      </div>
                      <div className='w-full'>
                        <h5
                          className={`text-[13px] ${item?.read_at === null ? 'font-bold' : ''
                            }`}
                        >
                          {/* mb-[2px]  */}
                          <b>{item?.data?.name}</b>
                          <p
                            className={`text-[12px]  float-right ${item?.read_at === null
                              ? 'font-bold text-[#0560FB]'
                              : 'text-[#1b252f99] text-[500]'
                              }`}
                          >
                            {moment(
                              item?.date.toString().slice(12, 19),
                              'HH:mm A'
                            ).format('HH:mm')}{' '}
                            hrs{' '}
                          </p>
                        </h5>
                        <p
                          className={`text-[#1b252f99] text-[12px] text-[500] flex items-center justify-between ${item?.read_at === null ? 'font-bold ' : ''
                            }`}
                        >
                          <span className='inline-block min-h-[18.01px]'>
                            {item?.data?.make}
                          </span>
                          {item?.read_at === null && (
                            <span className='h-[9px] w-[9px] bg-[#0560FB] rounded-[50%] flex-shrink-0'></span>
                          )}
                        </p>
                        <p
                          className={`text-[#1b252f99] text-[12px] text-[500] flex justify-between gap-[10px] ${item?.read_at === null ? 'font-bold ' : ''
                            }`}
                        >
                          <span className='truncate'>
                            {item?.data?.vehicle_no}
                            {'  '} {item?.reason}
                          </span>
                    
                          {item?.product_info === null && (
                            <span
                              className='flex-shrink-0'
                              style={{ color: '#0560FB' }}
                              onClick={() => {
                                onFilterRead('read', [item?.id]);
                                setTimeout(() => {
                                  navigate('/flooring-cases/view', {
                                    state: {
                                      appId: item?.application_id,
                                      submitted_date: '',
                                      expiry_date: '',
                                      isOngoing: true,
                                      pagePermission: FloorPagePErmission,
                                    },
                                  });
                                }, 1500);
                              }}
                            >
                              {'View >'}
                            </span>
                          )}
                        </p>
                      </div>
                    </div>
                  </div>
                </div>
              </>
            );
          })
        ) : (
          <div className='p-[10px_15px]'>
            {!loading && 'No Notifications Found...!'}
          </div>
        )}
      </div>
    </>
  );
};

export default FlooringNotificationBar;
